import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensProvidersSummaries} from './citizens-providers-summaries.model';

export const loadCitizensProvidersSummariess = createAction(
  '[CitizensProvidersSummaries/API] Load CitizensProvidersSummariess',
  props<{ citizensProvidersSummariess: CitizensProvidersSummaries[] }>()
);

export const addCitizensProvidersSummaries = createAction(
  '[CitizensProvidersSummaries/API] Add CitizensProvidersSummaries',
  props<{ citizensProvidersSummaries: CitizensProvidersSummaries }>()
);

export const upsertCitizensProvidersSummaries = createAction(
  '[CitizensProvidersSummaries/API] Upsert CitizensProvidersSummaries',
  props<{ citizensProvidersSummaries: CitizensProvidersSummaries }>()
);

export const addCitizensProvidersSummariess = createAction(
  '[CitizensProvidersSummaries/API] Add CitizensProvidersSummariess',
  props<{ citizensProvidersSummariess: CitizensProvidersSummaries[] }>()
);

export const upsertCitizensProvidersSummariess = createAction(
  '[CitizensProvidersSummaries/API] Upsert CitizensProvidersSummariess',
  props<{ citizensProvidersSummariess: CitizensProvidersSummaries[] }>()
);

export const updateCitizensProvidersSummaries = createAction(
  '[CitizensProvidersSummaries/API] Update CitizensProvidersSummaries',
  props<{ citizensProvidersSummaries: Update<CitizensProvidersSummaries> }>()
);

export const updateCitizensProvidersSummariess = createAction(
  '[CitizensProvidersSummaries/API] Update CitizensProvidersSummariess',
  props<{ citizensProvidersSummariess: Update<CitizensProvidersSummaries>[] }>()
);

export const deleteCitizensProvidersSummaries = createAction(
  '[CitizensProvidersSummaries/API] Delete CitizensProvidersSummaries',
  props<{ id: string }>()
);

export const deleteCitizensProvidersSummariess = createAction(
  '[CitizensProvidersSummaries/API] Delete CitizensProvidersSummariess',
  props<{ ids: string[] }>()
);

export const clearCitizensProvidersSummariess = createAction(
  '[CitizensProvidersSummaries/API] Clear CitizensProvidersSummariess'
);


//CUSTOM

export const citizenGetProvidersSummaries = createAction(
  '[CitizensProvidersSummaries/API] citizen Get Providers Summaries'
);
